import React from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Slider from "react-slick";

const MainSlider = ({ banners, afterLoginBanner }) => {
  const { isAuth } = useSelector((state) => state.auth);
  const isDesktop = window?.screen?.width > 767 ? true : false;

  const slidesToShow = isDesktop ? 3 : 1;
  const settings = {
    dots: true,
    // fade: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
  };
  return (
    <div>
      <Slider {...settings}>
        {banners &&
          banners?.map((item, index) => {
            const btn = item?.ctabtns || [];
            btn?.sort((a, b) => a.order - b.order);
            return (
              <div
                className="position-relative d-flex align-items-center"
                key={index}
              >
                <img
                  src={item?.link}
                  // style={{ aspectRatio: "16/9", objectFit: "cover" }}
                />
                {btn?.length > 0 &&
                  btn?.map((b, i) => {
                    return (
                      <div className="banner-btn " key={`${i}_${b?.label}`}>
                        <Button
                          onClick={() => {
                            window.location.href = b.actionLink;
                          }}
                          className="start-btn"
                        >
                          {b.label}
                        </Button>
                      </div>
                    );
                  })}
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default MainSlider;
